import React, { useState, useEffect } from "react";
import { putLocalidad } from "../helpers/rutaLocalidades"; // 👈 Cambiado el import
import { Modal, Button } from "react-bootstrap";
import { getLocalidades } from "../helpers/rutaLocalidades";
import { getProvincias } from "../helpers/rutaProvincias";

const ModalFormLocalidad = ({ localidad, handleClose }) => {
  // Controlar si localidad viene bien formateada
  const [showSuccess, setShowSuccess] = useState(false);
  
  const data = localidad.localidades || localidad; // Soporte para distintas llamadas

  const [formValues, setFormValues] = useState({
    localidad: data?.localidad || "",
    codigopostal: data?.codigopostal || "",
    provincia: data?.provincia?._id || data?.provincia || "", // Soporta id o el objeto
  });

  // Actualiza los valores si cambian (ej. al editar otro registro)
  useEffect(() => {
    setFormValues({
      localidad: data?.localidad || "",
      codigopostal: data?.codigopostal || "",
      provincia: data?.provincia?._id || data?.provincia || "",
    });
  }, [localidad]);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const id = data?._id || localidad._id;

    try {
      const resp = await putLocalidad(id, formValues);
      console.log("✅ Localidad actualizada:", resp);

      setShowSuccess(true); // Mostrar modal de éxito

      setTimeout(() => {
        setShowSuccess(false); // Ocultar el mensaje
        handleClose();         // Cerrar modal principal
      }, 2000);
    } catch (error) {
      console.error("❌ Error al guardar localidad:", error);
      // Modal de error opcional
    }
  };


  // Cargar provincias para el select
  const [provincias, setProvincias] = useState({
    data: { provincias: [] },
    loading: true,
  });

  useEffect(() => {
    getProvincias().then((provincias) => {
      setProvincias({
        data: provincias,
        loading: false,
      });
    });
  }, []);

  return (
    <>
      {!provincias.loading && (
        <form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="form-group mt-3">
              <label>Localidad</label>
              <input
                type="text"
                className="form-control"
                name="localidad"
                maxLength="50"
                minLength="2"
                required
                value={formValues.localidad}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mt-3">
              <label>Cod Postal</label>
              <input
                type="text"
                className="form-control"
                name="codigopostal"
                maxLength="4"
                minLength="4"
                required
                value={formValues.codigopostal}
                onChange={handleChange}
              />
            </div>
            <div className="form-group mt-3">
              <label>Provincia</label>
              <select
                className="form-control"
                name="provincia"
                value={formValues.provincia}
                onChange={handleChange}
                required
              >
                <option value="">Elija la opción adecuada</option>
                {provincias.data.provincias.map((provincia) => (
                  <option key={provincia._id} value={provincia._id}>
                    {provincia.provincia}
                  </option>
                ))}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="dark">
              Guardar
            </Button>
          </Modal.Footer>
        </form>
      )}
      
          <Modal
            show={showSuccess}
            centered
            backdrop="static"
            keyboard={false}
            dialogClassName="animate__animated animate__fadeInDown"
          >
            <Modal.Body className="text-center">
              <div style={{ fontSize: "3rem" }}>🖐</div>
              <h5 className="mt-2">¡Cambios guardados correctamente!</h5>
            </Modal.Body>
          </Modal>
    </>
  );
};

export default ModalFormLocalidad;


